import {
  ChartRow,
  ChartRowElement,
  ChartRowGroup,
  ChartSubsection,
  ChartSubsectionContent,
  ChartSubsectionHeader,
} from "modules/charts-shared";
import { RADIOLOGY_GRID_COLUMNS } from "../radiology-chart/constants";
import { RadiologyInterpretationProps } from "../radiology-chart/types";
import { useFormContext } from "react-hook-form";

function F014Interpretation(props: RadiologyInterpretationProps) {
  const {
    index,
    chartCode,
    encounterId,
    sectionId,
    sectionCode,
    sectionSubCode,
    onRemoveElement,
  } = props;

  const { watch } = useFormContext();
  const sectionDelimiter = `rad.${index}.${chartCode}${sectionId}${sectionCode}${sectionSubCode}`;

  const isQ001A013Checked = Boolean(watch(`${sectionDelimiter}Q001A013`));
  const isQ001A014Checked = Boolean(watch(`${sectionDelimiter}Q001A014`));
  const isQ001A015Checked = Boolean(watch(`${sectionDelimiter}Q001A015`));
  const isQ001A016Checked = Boolean(watch(`${sectionDelimiter}Q001A016`));
  const isQ001A017Checked = Boolean(watch(`${sectionDelimiter}Q001A017`));

  return (
    <ChartSubsection
      header={
        <ChartSubsectionHeader
          showNotesBtn
          showDeleteBtn
          chartId={chartCode}
          encounterId={encounterId}
          sectionId={sectionCode}
          showInteractions={false}
          subsectionId={`${sectionSubCode}_Q001`}
          subsectionLabel="Phalanx"
          showAuditsBtn={false}
          onDeleteSubSection={() => onRemoveElement(sectionId)}
        />
      }
      content={
        <ChartSubsectionContent>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement
                label="Phalanx:"
                name={`${sectionDelimiter}Q001A001`}
                type="cross-option"
              />
              <ChartRowElement
                label="L"
                name={`${sectionDelimiter}Q001A002`}
                type="cross-option"
              />
              <ChartRowElement
                label="R"
                name={`${sectionDelimiter}Q001A003`}
                type="cross-option"
              />
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="1st"
                name={`${sectionDelimiter}Q001A004`}
                type="cross-option"
              />
              <ChartRowElement
                label="2nd"
                name={`${sectionDelimiter}Q001A005`}
                type="cross-option"
              />
              <ChartRowElement
                label="3rd"
                name={`${sectionDelimiter}Q001A006`}
                type="cross-option"
              />
              <ChartRowElement
                label="4th"
                name={`${sectionDelimiter}Q001A007`}
                type="cross-option"
              />
              <ChartRowElement
                label="5th"
                name={`${sectionDelimiter}Q001A008`}
                type="cross-option"
              />
              <ChartRowElement
                label="lat malleous"
                name={`${sectionDelimiter}Q001A009`}
                type="cross-option"
              />
              <ChartRowElement
                label="med malleous"
                name={`${sectionDelimiter}Q001A010`}
                type="cross-option"
              />
              <ChartRowElement
                label="bimalleolar"
                name={`${sectionDelimiter}Q001A011`}
                type="cross-option"
              />
              <ChartRowElement
                label="SH:"
                name={`${sectionDelimiter}Q001A012`}
                type="cross-option"
              />
              <ChartRowElement
                label="1"
                name={`${sectionDelimiter}Q001A013`}
                type="cross-option"
                isDisabled={
                  isQ001A014Checked ||
                  isQ001A015Checked ||
                  isQ001A016Checked ||
                  isQ001A017Checked
                }
              />
              <ChartRowElement
                label="2"
                name={`${sectionDelimiter}Q001A014`}
                type="cross-option"
                isDisabled={
                  isQ001A013Checked ||
                  isQ001A015Checked ||
                  isQ001A016Checked ||
                  isQ001A017Checked
                }
              />
              <ChartRowElement
                label="3"
                name={`${sectionDelimiter}Q001A015`}
                type="cross-option"
                isDisabled={
                  isQ001A013Checked ||
                  isQ001A014Checked ||
                  isQ001A016Checked ||
                  isQ001A017Checked
                }
              />
              <ChartRowElement
                label="4"
                name={`${sectionDelimiter}Q001A016`}
                type="cross-option"
                isDisabled={
                  isQ001A013Checked ||
                  isQ001A014Checked ||
                  isQ001A015Checked ||
                  isQ001A017Checked
                }
              />
              <ChartRowElement
                label="5"
                name={`${sectionDelimiter}Q001A017`}
                type="cross-option"
                isDisabled={
                  isQ001A013Checked ||
                  isQ001A014Checked ||
                  isQ001A015Checked ||
                  isQ001A016Checked
                }
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A018`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="nondisplaced"
                name={`${sectionDelimiter}Q001A019`}
                type="cross-option"
              />
              <ChartRowElement
                label="displaced"
                name={`${sectionDelimiter}Q001A020`}
                type="cross-option"
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A021`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
        </ChartSubsectionContent>
      }
    />
  );
}

export { F014Interpretation };
